import { listenDialogsControls } from '@frontend/shared/src/utils/dialog';
import { PersistentBookmarks } from '@frontend/auction/src/helpers/PersistentBookmarks';
import { SPAList } from '@frontend/auction/src/components/spa-list';
import { SPAListPreview } from '@frontend/auction/src/components/spa-list-preview';

export class SPADialogBookmarks extends HTMLDialogElement {
  container: HTMLDivElement;
  save: HTMLButtonElement;

  constructor() {
    super();

    this.container = this.querySelector<HTMLDivElement>('.container')!;
    this.save = this.querySelector<HTMLButtonElement>('[data-save]')!;

    this.prepend(this.container);
  }

  connectedCallback() {
    listenDialogsControls('bookmarks', this.beforeOpen, this.afterClose);
  }

  updateList = () => {
    this.container.innerHTML = '';

    const bookmarks = PersistentBookmarks.load();

    const items = bookmarks.map(list => {
      const listPreview = new SPAListPreview().init(list);

      listPreview.onlistremove = () => {
        listPreview.remove();

        PersistentBookmarks.delete(list.id);
      };

      listPreview.onlistload = () => {
        SPAList.singleton.load(list.items);
      };

      return listPreview;
    });

    this.container.append(...items);
  };

  beforeOpen = () => {
    this.updateList();

    this.save.onclick = () => {
      PersistentBookmarks.save(
        SPAList.singleton
          .getItems()
          .map(({ name, sum }) => ({ name, sum }))
          .filter(item => item.name !== '' || item.sum !== 0)
      );

      this.updateList();
    };
  };

  afterClose = () => {
    this.container.innerHTML = '';
  };
}

customElements.define('spa-dialog-bookmarks', SPADialogBookmarks, { extends: 'dialog' });
